<template>
  <v-app>
    <v-container fluid class="fill-height pa-0 screen">
      <v-row no-gutters class="fill-height">
        <v-col cols="8" class="pa-10 left">
          <div class="logo">
            <v-img
              src="@/assets/zaturdaylogobluewithtext.png"
              width="300"
              height="70"
              style="margin-left: -2rem"
              @click="BackToMainMenu()"
            />
          </div>
          <div class="room-title">{{ roomName }}</div>
          <v-divider class="underline"></v-divider>
          <div
            class="status-label"
            :class="currentMeeting ? 'occupied' : 'available'"
          >
            {{ currentMeeting ? "Meeting Now" : "Available" }}
          </div>

          <div v-if="currentMeeting">
            <div
              style="
                font-size: 85px;
                color: #0010a3;
                font-weight: 700;
                padding-left: 15px;
              "
            >
              {{ format(currentMeeting?.start) }} -
              {{ format(currentMeeting?.end) }}
            </div>

            <div
              style="
                font-size: 50px;
                color: #000000;
                font-weight: 400;
                padding-left: 15px;
              "
            >
              {{ currentMeeting?.title }}
            </div>

            <div
              style="
                font-size: 32px;
                font-weight: 400;
                padding-left: 15px;
                color: #00378e;
              "
            >
              {{ currentMeeting?.organizer }}
            </div>
            <div
              class="mt-8 action-buttons"
              v-if="currentMeeting.checkInStatus == false"
            >
              <v-btn
                x-large
                class="btn-checkin"
                @click="OpenCheckinDialog(currentMeeting)"
                >Check in</v-btn
              >
              <v-btn x-large class="btn-release"> End & Release </v-btn>
            </div>
            <div class="mt-8 action-buttons" v-else>
              <v-btn x-large class="btn-checkout" @click="CheckOutDialog = true"
                >Check Out</v-btn
              >
              <v-btn x-large class="btn-extend" @click="ExtendDialog = true"
                ><v-icon size="25" color="black" class="mr-3"
                  >mdi-plus-circle</v-icon
                >Extend</v-btn
              >
            </div>
          </div>
        </v-col>

        <v-col cols="4">
          <div class="right-panel pa-6">
            <div class="clock-section text-center">
              <div class="clock-time" @click="ReloadPage()">{{ time }}</div>
              <div class="clock-date">{{ date }}</div>
            </div>
            <div class="next-title mt-10">
              <span>
                <v-img
                  src="@/assets/icons/Triangle.png"
                  width="35"
                  height="35"
                />
              </span>
              <span class="ml-3">NEXT MEETING</span>
            </div>
            <div class="mt-2">
              <v-card
                v-for="(item, i) in reservations || []"
                :key="i"
                class="meeting-card mb-3"
                :class="{ active: isCurrentMeeting(item) }"
                elevation="0"
              >
                <div class="meeting-time">
                  {{ item?.start ? format(item.start) : "" }} –
                  {{ item?.end ? format(item.end) : "" }}
                </div>

                <div class="meeting-title">
                  {{ item.title }}
                </div>

                <div class="meeting-organizer">
                  {{ item.organizer }}
                </div>
              </v-card>
              <v-btn block x-large class="book-btn mt-3" @click="ReserveRoom()">
                Book Now
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="NewBookingDialog" max-width="1200" persistent>
      <v-card class="booking-wrapper">
        <v-container class="booking-container">
          <div class="booking-header">{{ roomName }}</div>
          <div class="booking-clock">
            <div class="booking-time">{{ time }}</div>
            <div class="booking-date">{{ date }}</div>
          </div>
          <v-row dense class="mb-6">
            <v-col cols="12" md="6">
              <div class="booking-pill-wrapper">
                <span class="booking-label">Meeting Name :</span>
                <v-text-field
                  v-model="title"
                  solo
                  flat
                  dense
                  hide-details
                  class="booking-pill-input"
                />
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="booking-pill-wrapper">
                <span class="booking-label">Host Name :</span>
                <v-text-field
                  v-model="organizer"
                  solo
                  flat
                  dense
                  disabled
                  hide-details
                  class="booking-pill-input"
                />
              </div>
            </v-col>
          </v-row>

          <v-card class="booking-time-card" flat>
            <v-row align="center">
              <v-col cols="12" md="6" class="d-flex justify-center">
                <div class="time-row">
                  <span
                    size="29"
                    class="booking-label"
                    @click="adjustStartTime(-1)"
                    >Start Time :</span
                  >
                  <v-icon color="red">mdi-minus-circle-outline</v-icon>
                  <v-autocomplete
                    v-model="StartTime"
                    :items="timeOptions"
                    solo
                    flat
                    hide-details
                    class="booking-pill-time-input"
                    menu-props="auto"
                  />
                  <v-icon size="29" color="#00378E" @click="adjustStartTime(1)"
                    >mdi-plus-circle-outline</v-icon
                  >
                </div>
              </v-col>

              <v-col cols="12" md="6" class="d-flex justify-center">
                <div class="time-row">
                  <span class="booking-label">To :</span>
                  <v-icon size="29" color="red" @click="adjustEndTime(-1)"
                    >mdi-minus-circle-outline</v-icon
                  >
                  <v-autocomplete
                    v-model="EndTime"
                    :items="timeOptions"
                    solo
                    flat
                    hide-details
                    class="booking-pill-time-input"
                  />
                  <v-icon size="29" color="#00378E" @click="adjustEndTime(1)"
                    >mdi-plus-circle-outline</v-icon
                  >
                </div>
              </v-col>
            </v-row>

            <div class="duration-wrapper">
              <div class="duration-pill">
                Duration :
                <strong>{{ durationHour }}</strong> Hour
                <strong>{{ durationMinute }}</strong> Min
              </div>
            </div>
          </v-card>
        </v-container>

        <v-card-actions class="booking-actions">
          <v-btn x-large class="cancel-btn" @click="NewBookingDialog = false">
            Cancel
          </v-btn>
          <v-btn x-large class="confirm-btn" @click="createBooking()">
            Book a Meeting
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SuccessNewBookingDialog" max-width="650px" he persistent>
      <v-card class="booking-wrapper">
        <v-card class="pt-5 pb-5">
          <div class="success-wrapper">
            <div class="success-icon">
              <v-icon size="46" color="white">mdi-check</v-icon>
            </div>
            <div class="success-title">Your Booking Is Successful</div>
            <div class="success-info">
              <div class="info-row">
                <span>Date</span>
                <span>:</span>
                <span>{{ bookingDate }}</span>
              </div>
              <div class="info-row">
                <span>Time</span>
                <span>:</span>
                <span>{{ bookingTime }}</span>
              </div>
              <div class="info-row">
                <span>Room</span>
                <span>:</span>
                <span>{{ roomName }}</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckinDialog" max-width="650px" he persistent>
      <v-card class="booking-wrapper">
        <v-card class="pt-5 pb-5">
          <div class="success-wrapper">
            <div class="success-title">Check In</div>
            <div class="mt-3">
              <qrcode-vue :value="QRData" size="150" level="M" />
            </div>
            <div class="success-info">
              <p
                style="
                  font-size: 28px;
                  font-weight: 700;
                  color: #0f3f8c;
                  text-align: center;
                "
              >
                {{ bookingName }}
              </p>
              <div class="info-row">
                <span>Date</span>
                <span>:</span>
                <span style="text-align: center">{{ bookingDate }}</span>
              </div>
              <div class="info-row">
                <span>Time</span>
                <span>:</span>
                <span style="text-align: center">{{ bookingTime }}</span>
              </div>
              <div class="info-row">
                <span>Room</span>
                <span>:</span>
                <span style="text-align: center">{{ roomName }}</span>
              </div>
            </div>
          </div>
          <v-row class="mt-3">
            <v-col cols="12" md="12" align="center">
              <v-btn x-large class="btn-release" @click="CheckinDialog = false"
                >Close</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ExtendDialog" max-width="770" persistent>
      <v-card class="extend-wrapper">
        <v-row class="extend-icon-wrapper">
          <div>
            <v-img width="90" height="90" src="@/assets/icons/clock.png" />
          </div>
        </v-row>
        <div class="extend-title">Extend this meeting?</div>
        <div class="extend-current">
          Current :
          <span
            >{{ format(currentMeeting?.start) }} -
            {{ format(currentMeeting?.end) }}</span
          >
        </div>
        <div class="extend-new">
          Extended: <span>{{ ExtendStartTime }} - {{ ExtendExpireTime }}</span>
        </div>
        <v-row class="extend-options" justify="center">
          <v-col cols="4" v-for="min in extendOptions" :key="min">
            <div
              class="extend-card"
              :class="{
                active: selectedExtend === min,
                disabled: !canExtend(min),
              }"
              @click="canExtend(min) && selectExtend(min)"
            >
              <div class="extend-number">{{ min }}</div>
              <div class="extend-text">Min</div>
            </div>
          </v-col>
        </v-row>
        <div class="extend-actions">
          <v-btn class="btn-cancel" x-large @click="ExtendDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="#00378E" class="btn-confirm" x-large> Confirm </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="CheckOutDialog" max-width="650px" he persistent>
      <v-card class="rounded-xl elevation-4 pa-6" max-width="800" width="100%">
        <v-card-title class="justify-center pb-4 text-center">
          <span class="text-h6 font-weight-bold"> Check Out </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="CheckOutDialog = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-container>
            <v-row dense>
              <v-col cols="12" md="6">
                <p style="font-size: 18px">
                  <b style="color: black">Booking Name :</b>
                  {{ currentMeeting?.title }}
                </p>
                <p style="font-size: 18px">
                  <b style="color: black">Date/Time :</b>
                  {{ format(currentMeeting?.start) }} –
                  {{ format(currentMeeting?.end) }}
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <p style="font-size: 18px">
                  <b style="color: black">Room :</b> {{ roomName }}
                </p>
                <p style="font-size: 18px">
                  <b style="color: black">HostName :</b>
                  {{ currentMeeting?.organizer }}
                </p>
              </v-col>
            </v-row>
            <v-row dense justify="center" class="pt-6">
              <v-col cols="12" md="8" class="d-flex justify-center">
                <v-btn
                  color="red"
                  width="150"
                  class="mr-4 white--text rounded-lg"
                  large
                  @click="checkOutMeeting(currentMeeting)"
                >
                  Check Out
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="SuccessCheckOutDialog" max-width="650px" he persistent>
      <v-card class="booking-wrapper">
        <v-card class="pt-5 pb-5">
          <div class="success-wrapper">
            <div class="success-icon">
              <v-icon size="46" color="white">mdi-check</v-icon>
            </div>
            <div class="success-title">Check Out Successful</div>
          </div>
        </v-card>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import dayjs from "dayjs";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import QrcodeVue from "qrcode.vue";
export default {
  name: "MeetingRoomScreen",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      roomName: "",
      available: true,
      time: "",
      date: "",
      loading: false,
      reservations: [],

      NewBookingDialog: false,
      SuccessNewBookingDialog: false,
      CheckinDialog: false,
      ExtendDialog: false,
      CheckOutDialog: false,
      SuccessCheckOutDialog: false,
      duration: 30,
      title: "",
      organizer: "",
      QRData: "",

      StartDate: new Date().toISOString().slice(0, 10),
      EndDate: new Date().toISOString().slice(0, 10),
      StartTime: "",
      EndTime: "",
      bookingID: null,
      bookingDate: "",
      bookingTime: "",
      bookingName: "",

      extendOptions: [15, 30, 60],
      selectedExtend: null,
      ExtendStartTime: "",
      ExtendExpireTime: "",
    };
  },

  mounted() {
    let self = this;
    self.updateClock();
    self.getDataUserPad();
    setInterval(self.updateClock, 1000);
    self.getDataTodayMeetings();
    setInterval(self.getDataTodayMeetings, 60000);
  },

  created() {
    // const times = [];
    // for (let h = 0; h < 24; h++) {
    //   for (let m = 0; m < 60; m++) {
    //     times.push(
    //       `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
    //     );
    //   }
    // }
    // this.timeOptions = times;

    const times = [];
    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m++) {
        const totalMinutes = h * 60 + m;

        if (totalMinutes >= nowMinutes) {
          times.push(
            `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
          );
        }
      }
    }
    this.timeOptions = times;
  },

  computed: {
    nextMeeting() {
      const now = dayjs();
      return this.reservations
        .filter((r) => now.isBefore(r.start))
        .sort((a, b) => a.start.valueOf() - b.start.valueOf())[0];
    },

    currentMeeting() {
      const now = dayjs();
      return this.reservations.find((r) => {
        if (!r.start || !r.end) return false;
        return now.isAfter(r.start) && now.isBefore(r.end);
      });
    },

    statusText() {
      if (!this.currentMeeting) {
        return "Available";
      }
      return `Occupied ${this.format(
        this.currentMeeting.start
      )} - ${this.format(this.currentMeeting.end)}`;
    },

    statusTitle() {
      return this.currentMeeting?.title ?? "";
    },

    durationDiff() {
      if (!this.StartTime || !this.EndTime){
        return 0;
      }
      const [sh, sm] = this.StartTime.split(":").map(Number);
      const [eh, em] = this.EndTime.split(":").map(Number);
      const startMinutes = sh * 60 + sm;
      const endMinutes = eh * 60 + em;
      const diff = endMinutes - startMinutes;
      return diff > 0 ? diff : 0;
    },

    durationHour() {
      return Math.floor(this.durationDiff / 60);
    },

    durationMinute() {
      return this.durationDiff % 60;
    },
  },

  methods: {
    async getDataTodayMeetings() {
      let self = this;
      self.LoadingDialog = true;
      try {
        const res = await axios.get(
          `${self.url}Calendar/getDataTodayMeetingsOffice365`
        );

        if (res.data.status === 0) {
          const data = res.data.data;
          self.reservations = data
            .filter((e) => e.startDate && e.expireDate)
            .map((e) => ({
              id: e.id,
              start: dayjs(e.startDate),
              end: dayjs(e.expireDate),

              time: `${dayjs(e.startDate).format("HH:mm")} - ${dayjs(
                e.expireDate
              ).format("HH:mm")}`,

              title: e.bookingName || "No title",
              organizer: e.hostName || "-",
              checkInStatus: e.checkInStatus,
              eventID: e.eventID,
            }));
          self.checkRoomStatus();
        } else {
          self.reservations = [];
          self.available = true;
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

        Swal.fire({
          icon: "warning",
          width: 900,
          text: message,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    async getDataUserPad() {
      let self = this;
      self.LoadingDialog = true;
      try {
        const res = await axios.get(`${self.url}Calendar/getDataUserInPad`);
        if (res.data.status === 0) {
          self.BindingData(res.data.data);
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

        Swal.fire({
          icon: "warning",
          width: 900,
          text: message,
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    OpenCheckinDialog(data) {
      let self = this;
      self.bookingID = data.id;
      self.bookingName = data.title;
      self.bookingDate = self.formatDate(data.start);
      self.bookingTime = data.time;
      self.QRData =
        "https://roombooking.objective-faraday.119-59-118-127.plesk.page/CheckinMeeting/" + data.id;
      self.CheckinDialog = true;
    },

    checkInMeeting(id) {
      let self = this;
      let temp = {
        id: id,
      };
      axios
        .post(`${self.url}Calendar/checkInMeetingOffice365ByID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.bookingDate = response.data.data.bookingDate;
            self.bookingTime = response.data.data.bookingTime;
            self.SuccessNewBookingDialog = true;
            self.clearDateCreateMeeting();
            self.getDataTodayMeetings();
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    BindingData(data) {
      let self = this;
      self.roomName = data.roomPadDetail.name;
      self.organizer = data.userName;
    },

    format(d) {
      if (!d) return "";
      return dayjs(d).format("HH:mm");
    },

    formatDate(d) {
      if (!d) return "";
      return dayjs(d).format("DD/MM/YYYY");
    },

    // checkRoomStatus() {
    //   const now = dayjs();
    //   const currentMeeting = this.reservations.find(
    //     (r) => now.isAfter(r.start) && now.isBefore(r.end)
    //   );
    //   this.available = !currentMeeting;
    // },

    checkRoomStatus() {
      let self = this;
      const today = dayjs();
      const currentMeeting = self.reservations.find((r) =>
        today.isSame(r.start, "day")
      );
      self.available = !currentMeeting;
    },

    updateClock() {
      let self = this;
      const now = new Date();
      self.time = now.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
      });

      self.date = now.toLocaleDateString("th-TH", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    isCurrentMeeting(item) {
      if (!item || !item.start || !item.end){
        return false;
      }
      const now = dayjs();
      return now.isAfter(item.start) && now.isBefore(item.end);
    },

    ReserveRoom() {
      let self = this;
      self.title = "";
      self.StartTime = "00:00";
      self.EndTime = "00:00";
      self.NewBookingDialog = true;
    },

    createBooking() {
      let self = this;
      let temp = {
        title: self.title,
        organizer: self.organizer,
        startDate: self.StartDate,
        startTime: self.StartTime,
        endDate: self.EndDate,
        endTime: self.EndTime,
      };
      axios
        .post(`${self.url}Calendar/createMeetingOffice365`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.bookingName = response.data.data.bookingName;
            self.bookingDate = response.data.data.bookingDate;
            self.bookingTime = response.data.data.bookingTime;
            self.SuccessNewBookingDialog = true;
            self.clearDateCreateMeeting();
          }
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    clearDateCreateMeeting() {
      let self = this;
      self.title = "";
      self.organizer = "";
      self.StartTime = "";
      self.EndTime = "";
      self.NewBookingDialog = false;
      setTimeout(() => {
        self.SuccessNewBookingDialog = false;
        self.CheckOutDialog = false;
        self.getDataTodayMeetings();
      }, 3000);
    },

    BackToMainMenu() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    ReloadPage() {
      location.reload();
    },

    adjustStartTime(step) {
      let self = this;
      if (!self.StartTime) {
        self.StartTime = self.timeOptions[0];
        return;
      }
      const index = self.timeOptions.indexOf(self.StartTime);
      if (index === -1){
        return;
      }
      let newIndex = index + step;
      if (newIndex < 0){
         newIndex = 0;
      }
      if (newIndex >= self.timeOptions.length){
        newIndex = self.timeOptions.length - 1;
      }
      self.StartTime = self.timeOptions[newIndex];
    },

    adjustEndTime(step) {
      let self = this;
      if (!self.EndTime) {
        self.EndTime = self.timeOptions[0];
        return;
      }

      const index = self.timeOptions.indexOf(self.EndTime);
      if (index === -1){
        return;
      }
      let newIndex = index + step;
      if (newIndex < 0){
        newIndex = 0;
      }
      if (newIndex >= self.timeOptions.length){
        newIndex = self.timeOptions.length - 1;
      }
      self.EndTime = self.timeOptions[newIndex];
    },

    checkOutMeeting(data) {
      let self = this;
      let temp = {
        eventID: data.eventID,
      };
      axios
        .post(`${self.url}Calendar/checkOutMeetingOffice365ByEventID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.SuccessCheckOutDialog = true;
            setTimeout(() => {
              self.SuccessCheckOutDialog = false;
              self.getDataTodayMeetings();
            }, 3000);
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    selectExtend(min) {
      let self = this;
      if (!self.currentMeeting){
        return;
      }
      self.selectedExtend = min;
      const start = dayjs(self.currentMeeting.start);
      const end = dayjs(self.currentMeeting.end);

      self.ExtendStartTime = start.format("HH:mm");
      self.ExtendExpireTime = end.add(min, "minute").format("HH:mm");
    },

    getNextMeeting() {
      let self = this;
      if (!self.currentMeeting || !self.currentMeeting.end){
         return null;
      }
      const now = dayjs(self.currentMeeting.end);
      const next = self.reservations
        .filter((r) => r.start && dayjs(r.start).isAfter(now))
        .sort((a, b) => a.start.valueOf() - b.start.valueOf())[0];
      return next || null;
    },

    canExtend(min) {
      let self = this;
      if (!self.currentMeeting || !self.currentMeeting.end){
        return false;
      }
      const nextMeeting = self.getNextMeeting();
      if (!nextMeeting){
        return true;
      }
      const newEnd = dayjs(self.currentMeeting.end).add(min, "minute");
      return newEnd.isBefore(dayjs(nextMeeting.start));
    },

    confirmExtend() {
      // call API extend meeting
      console.log("extend", this.extendMin);
    },
  },
};
</script>
<style scoped>
.screen {
  background: url("~@/assets/backgroundroom.png");
  background-size: cover;
  background-position: left 80%;
  background-repeat: no-repeat;
  background-size: cover;
}

.left {
  position: relative;
}

.right {
  background: #d9d9d9a8;
  backdrop-filter: blur(10px);
}

.room {
  font-size: 64px;
  font-weight: 400;
}
.room-title {
  font-size: 60px;
  font-weight: 700;
  color: #123c84;
  letter-spacing: 1px;
  margin-top: 30px;
}

.clock {
  position: absolute;
  bottom: 10px;
}

.right-panel {
  height: 100%;
  display: flex;
  flex-direction: column;

  background: rgba(165, 181, 206, 0.85);
  backdrop-filter: blur(6px);
}

.next-header {
  font-size: 36px;
  color: #00378e;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.time-text {
  color: #0010a3;
  font-size: 40px;
  font-weight: 600;
}

.title-text {
  font-size: 24px;
  color: black;
}

.org-text {
  font-size: 20px;
  color: white;
}

.status-label {
  margin-top: 40px;
  width: 250px;
  font-weight: 400;
  height: 62px;
  border-radius: 30px;
  font-size: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.status-label.available {
  background: linear-gradient(90deg, #39c145, #00378e);
}

.status-label.occupied {
  background: linear-gradient(90deg, #c00003, #00378e);
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.btn-checkin {
  background: #00378e !important;
  color: white !important;
  font-size: 18px;
  width: 195px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-release {
  background: #9a0003 !important;
  color: white !important;
  width: 195px;
  font-size: 18px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-checkout {
  background: #00378e !important;
  color: white !important;
  font-size: 18px;
  width: 195px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.btn-extend {
  background: #ebeae9 !important;
  color: #00378e !important;
  font-size: 18px;
  width: 195px;
  border-radius: 26px;
  box-shadow: 0px 3.46px 3.46px 0px #00000040;
  text-transform: none;
}

.underline {
  width: 800px;
  height: 3px;
  background: #123c84;
  margin-top: 12px;
}
.clock-time {
  font-size: 88px;
  font-weight: 700;
  color: #00378e;
  line-height: 1;
}

.clock-date {
  font-size: 22px;
  color: #00378e;
  margin-top: 8px;
}
.next-title {
  font-size: 40px;
  font-weight: 600;
  color: #0d3b8f;
  display: flex;
  align-items: center;
}

.meeting-title {
  font-size: 18px;
  margin-top: 8px;
  color: #222;
}

.meeting-organizer {
  font-size: 14px;
  margin-top: 6px;
  color: #00378e;
}

.meeting-card {
  border-radius: 18px;
  padding: 20px;
  background: #ffffff80;
  transition: 0.2s;
}

.meeting-card.active {
  background: #ffffff80 !important;
  color: white;
  box-shadow: 0px 4px 4px 0px #01378e !important;
}

.meeting-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12), 0 6px 0 rgba(0, 55, 142, 0.25);
}

.meeting-time {
  font-size: 40px;
  font-weight: 700;
  color: #00378e;
}

.meeting-title {
  font-size: 24px;
  margin-top: 1px;
  color: #222;
}

.meeting-organizer {
  font-size: 20px;
  margin-top: 6px;
  color: #00378e;
}

.book-btn {
  height: 67px;
  border-radius: 28px;
  background: linear-gradient(90deg, #0d3b8f, #001b5c);
  color: white;
  font-weight: 600;
  font-size: 18px;
  text-transform: none;
}

/* CLOCK */
.booking-clock {
  text-align: center;
  margin: 20px 0;
}

.booking-time {
  font-size: 64px;
  font-weight: 700;
  color: #0d3b8f;
}

.booking-date {
  font-size: 18px;
  color: #0d3b8f;
}

/* New Booking */
.booking-wrapper {
  border-radius: 28px;
  padding: 14px 40px;
  background: url("~@/assets/backgroundroom.png");
  background-size: cover;
  background-position: left bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.booking-header {
  background: #0d3b8f;
  color: white;
  text-align: center;
  padding: 12px;
  border-radius: 40px;
  font-size: 40px;
  font-weight: 800;
}

.close-btn {
  position: absolute;
  right: 10px;
  top: 6px;
  color: white;
}

.field-label {
  font-weight: 600;
  color: #0d3b8f;
  margin-bottom: 8px;
}

.pill-input input {
  text-align: center;
  font-weight: 600;
  color: #0d3b8f;
}

.booking-actions {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 30px;
}

.cancel-btn {
  background: #eef3fb !important;
  color: #00378e !important;
  border-radius: 30px;
  width: 180px;
  font-weight: 500;
  text-transform: none;
}

.confirm-btn {
  background: #00378e !important;
  color: white !important;
  border-radius: 30px;
  width: 180px;
  text-transform: none;
}

.booking-container {
  max-width: 1100px;
}
.booking-pill-wrapper {
  background: white;
  border-radius: 20px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
}

.booking-label {
  font-weight: 600;
  color: #0f3a8a;
  white-space: nowrap;
  font-size: 20px;
}

.booking-time-card {
  background: white;
  border-radius: 25px;
  padding: 30px;
}

.time-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  width: 320px;
  padding-left: 30px;
}

.time-pill .v-input__control {
  background: #d7dee9;
  border-radius: 25px;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
}

.duration-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}

.duration-pill {
  background: #ebf4ff;
  padding: 12px 40px;
  border-radius: 30px;
  font-size: 20px;
  color: #0f3a8a;
  font-weight: 600;
  width: 700px;
  text-align: center;
}
.booking-actions-bar {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  padding: 30px 60px;
  gap: 20px;
}

.booking-pill-input ::v-deep .v-input__slot {
  background: #ebf4ff !important;
  border-radius: 25px !important;
  box-shadow: none !important;
  /* padding: 0 16px !important; */
  min-height: 42px !important;
  display: flex;
  align-items: center;
}

.booking-pill-input ::v-deep .v-input__control {
  box-shadow: none !important;
}

.booking-pill-input ::v-deep input {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #0d3b8f;
}

.booking-pill-input.v-input--is-disabled ::v-deep .v-input__slot {
  opacity: 1 !important;
}

.booking-pill-time-input ::v-deep .v-input__slot {
  background: #ebf4ff !important;
  border-radius: 25px !important;
  box-shadow: none !important;
  /* padding: 0 16px !important; */
  min-height: 42px !important;
  display: flex;
  width: 250px;
  align-items: center;
}

.booking-pill-time-input ::v-deep .v-input__control {
  box-shadow: none !important;
}

.booking-pill-time-input ::v-deep input {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #0d3b8f;
}

.booking-pill-time-input.v-input--is-disabled ::v-deep .v-input__slot {
  opacity: 1 !important;
}

/* Success New Meeting */
.success-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.success-icon {
  width: 82px;
  height: 82px;
  background: #0f3f8c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-title {
  margin-top: 22px;
  font-size: 28px;
  font-weight: 700;
  color: #0f3f8c;
}
.success-info {
  margin-top: 32px;
  background: #dfe5ee;
  border-radius: 18px;
  padding: 28px 45px;
  width: 100%;
  max-width: 420px;
}
.info-row {
  display: grid;
  grid-template-columns: 120px 20px 1fr;
  font-size: 16px;
  margin-bottom: 14px;
  color: #1d2a44;
  font-weight: 500;
}
.info-row:last-child {
  margin-bottom: 0;
}

.extend-wrapper {
  padding: 50px 60px;
  border-radius: 30px;
  text-align: center;
}

.extend-icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.extend-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f3f8c;
}

.extend-current {
  margin-top: 10px;
  font-size: 18px;
  color: #333;
}

.extend-current span {
  font-weight: 600;
}

.extend-new {
  font-size: 18px;
  margin-top: 5px;
  color: #0f3f8c;
}

.extend-new span {
  font-weight: 700;
}

.extend-options {
  margin-top: 35px;
}

.extend-card {
  background: #ebeae9;
  border-radius: 30px;
  text-align: center;
  transition: 0.25s;
  cursor: pointer;
  height: 220px;
}

.extend-card.active {
  background: #ebeae9;
  box-shadow: 0px 5px 5px 0px #00378e;
}

.extend-number {
  font-size: 120px;
  font-weight: 800;
  color: #00378e;
}

.extend-text {
  font-size: 20px;
  color: #00378e;
  font-weight: 500;
}

.extend-actions {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 35px;
}

.extend-card.disabled {
  background: #eee;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-cancel {
  width: 200px;
  background: #dfe3ea;
  border-radius: 30px;
  padding: 14px 50px;
  text-transform: none;
  font-size: 16px;
  color: #00378e;
  font-weight: 600;
}

.btn-confirm {
  width: 200px;
  color: white;
  border-radius: 30px;
  padding: 14px 50px;
  text-transform: none;
  font-size: 16px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  font-weight: 600;
}
</style>

